import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import IdentityPortal from './IdentityPortal';
import { ReturnLocationProvider } from './ReturnTo';
import { theme } from './theme';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <ReturnLocationProvider>
            <IdentityPortal />
          </ReturnLocationProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
